// extracted by mini-css-extract-plugin
module.exports = {"partners":"index_partners__nR6qQ","cumTit":"index_cumTit__I9BBH","listContennt":"index_listContennt__RfbfI","listBox":"index_listBox__3eP_8"};